export const dictionary = {
    common: {
        ui: {
            menu: {
                main: {
                    sections: {
                        sensors: "Sensoren",
                        observations: "Beobachtungen",
                        modelling: "Modellierung",
                        mapFeatures: "Karten Merkmale",
                        output: "Exportieren & Berichten",
                        setUp: "Konfiguration",
                    },
                },
            },
        },
    },
    temporalUnits: {
        millis: { long: { singular: 'Millisekunde', plural: 'Millisekunden' }, short: { singular: 'Ms', plural: 'Ms' } },
        seconds: { long: { singular: 'Sekunde', plural: 'Sekunden' }, short: { singular: 'Sek.', plural: 'Seks.' } },
        minutes: { long: { singular: 'Minute', plural: 'Minuten' }, short: { singular: 'Min.', plural: 'Mins.' } },
        hours: { long: { singular: 'Stunde', plural: 'Stunden' }, short: { singular: 'Std.', plural: 'Std.' } },
        days: { long: { singular: 'Tag', plural: 'Tage' }, short: { singular: 'Tag', plural: 'Tage' } },
        weeks: { long: { singular: 'Woche', plural: 'Wochen' }, short: { singular: 'W.', plural: 'Ws.' } },
        months: { long: { singular: 'Monat', plural: 'Monate' }, short: { singular: 'Mon.', plural: 'Mon.' } },
        quarters: { long: { singular: 'Quartal', plural: 'Quartale' }, short: { singular: 'Qrt.', plural: 'Qrte.' } },
        years: { long: { singular: 'Jahr', plural: 'Jahre' }, short: { singular: 'Jr.', plural: 'Jre.' } },
    },
    timezone: "Zeitzone",
    custom: 'Benutzerdefiniert',
    period: 'Periode',
};
